import { useMemo } from "react";
import { getViewerCapabilities } from "@constructionautomation/backend/convex/lib/viewerCapabilities";
import { useUserProfile } from "@/components/auth";

/**
 * Role capabilities for the signed-in user, from the same helper the server's guide uses, so CTAs
 * match server authorization. Until the profile loads, nothing is offered.
 */
export function useViewerCapabilities() {
  const { userProfile } = useUserProfile();
  const role = userProfile?.orgRole ?? null;
  return useMemo(() => (role ? getViewerCapabilities(role) : null), [role]);
}
